import {
    ChangeDetectionStrategy,
    Component,
    inject,
    input,
    OnDestroy,
    OnInit,
} from '@angular/core';
import { BazisModalService } from '@bazis/shared/services/modal.service';
import { GalleryModalComponent } from '@bazis/shared/components/modals/gallery-modal.component';
import { EntData } from '@bazis/shared/models/srv.types';
import { CommonModule } from '@angular/common';
import { ButtonModule } from '@bazis/shared/components/web/button/button.module';
import { IconModule } from '@bazis/shared/components/web/icon/icon.module';
import { EntityPipe } from '@bazis/shared/pipes/entity.pipe';
import { GallerySkeletonComponent } from '@bazis/shared/components/gallery/gallery-skeleton.component';
import { SizeRange } from '@bazis/shared/models/base.types';

@Component({
    selector: 'bazis-gallery',
    templateUrl: './gallery.component.html',
    imports: [CommonModule, ButtonModule, IconModule, EntityPipe, GallerySkeletonComponent],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GalleryComponent implements OnDestroy, OnInit {
    public modalService = inject(BazisModalService);

    readonly imageEntities = input<EntData[]>();

    //  Если необходимо задать отличный от имени файла alt картинкам
    readonly imagesAlt = input<string[]>();

    readonly isPreview = input<boolean>();

    readonly size = input<SizeRange>();
    //                        mini     compact  large  regular huge  giant
    // readonly size = input<'mini' | 'small' | 'large'>();

    ngOnInit(): void {
        //this.isPreview = this.isPreview !== undefined && this.isPreview !== false;
    }

    ngOnDestroy(): void {}

    openGallery(gallery, index) {
        this.modalService.create({
            component: GalleryModalComponent,
            componentProperties: {
                gallery,
                startIndex: index,
                imagesAlt: this.imagesAlt(),
            },
            modalType: 'fullscreen gallery',
            hasCloseIcon: false,
        });
    }
}
